'use client';

import dynamic from 'next/dynamic';
import CategoryNavBig from '../../components/CategoryNavBig/CategoryNavBig';
import CategoryNavShape from '../../components/CategoryNavShape/CategoryNavShape';
import CategoryNavSmall from './components/CategoryNavSmall/CategoryNavSmall';
import HeroBanner from './components/HomeBanner/HomeBanner';
import OneRowFourNav from './components/OneRowFourNav/OneRowFourNav';
import FivePicSwiper from '../../components/FivePicSwiper/FivePicSwiper';
import type { HomeComponentMap } from '../../HomeSectionRenderer';
import MultiSwipe from './components/MultiSwipe/MultiSwipe';
import OneLineTwo2026 from './components/OneLineTwo/OneLineTwo';
import ImageTextGridNav from './components/ImageTextGridNav/ImageTextGridNav';
import ProductList2026 from './components/ProductList';
import Coupon from './components/Coupon/Coupon';
import { WaterFall2ColdReturnPlaceholder } from './components/WaterFall/WaterFall2InitialSkeleton';

// 2026 首屏组件会按设计稿逐项替换。swipeImage、categoryNavSmall 和 oneRowFourNav 已拆分为 2026 WAP 独立实现，
// 其他组件暂时显式复用旧实现；禁止通过 OLD_COMPONENT_MAP 做隐式回退。
// 新版组件禁止兼容旧装修 ID：oneLineTwo2026 只注册新版实现，不得保留 oneLineTwo 别名。
// multiSwipe 契约 ID 保持不变，但实现必须引用 2026 WAP 独立副本，禁止直接引用旧组件目录。
// imageTextGridNav 仅实现新版 content 契约和移动端布局，禁止接入旧注册表或旧组件兜底。
// regularList2026 仅注册 2026 WAP 独立副本，不得保留 regularList 兼容别名。
// 2026 WAP 装修注册严格使用 waterFall2；商品流接口的线上稳定 ID 仅在私有实现内部处理。
// brandImage 契约 ID 保持不变，但实现必须引用 2026 WAP 独立副本，禁止直接引用旧组件目录。
const BlogArticle = dynamic(() => import('../../components/BlogArticle/BlogArticle'), {
  ssr: false,
  loading: () => <div className="h-[200px] animate-pulse bg-[#f5f5f5]" />,
});
const BrandImage = dynamic(() => import('./components/BrandImage/BrandImage'), {
  ssr: false,
  loading: () => <div className="h-[100px] animate-pulse bg-[#f5f5f5]" />,
});
const StyleHub = dynamic(() => import('../../components/StyleHub/StyleHub'), {
  ssr: false,
  loading: () => <div className="h-[300px] animate-pulse bg-[#f5f5f5]" />,
});
const WaterFall2 = dynamic(() => import('./components/WaterFall/WaterFall2'), {
  ssr: false,
  loading: () => <WaterFall2ColdReturnPlaceholder />,
});

export const NEW_2026_COMPONENT_MAP: HomeComponentMap = {
  swipeImage2026: HeroBanner,
  oneRowFourNav: OneRowFourNav,
  categoryNavSmall: CategoryNavSmall,
  categoryNavShape: CategoryNavShape,
  categoryNavBig: CategoryNavBig,
  styleHub: StyleHub,
  multiSwipe: MultiSwipe,
  oneLineTwo2026: OneLineTwo2026,
  imageTextGridNav: ImageTextGridNav,
  multiSwipeSecond: FivePicSwiper,
  blogArticle: BlogArticle,
  brandImage: BrandImage,
  regularList2026: ProductList2026,
  waterFall2: WaterFall2,
  coupon: Coupon,
};
